import React from "react";
import { Button } from "@sscs/ui";
import {
  AddIcon,
  RemoveCircleIcon as RemoveCircleOutlineIcon,
} from "@sscs/ui/icons";
import { CATALOG_PUBLISH_CONDITION } from "Constants";
import { useDialog } from "Hooks";
import { useUpdatePackageMutation } from "Services";
import Dialog from "../Dialog/Dialog";

type AddToCatalogProps = {
  packageId: string;
  packageName: string;
  inCatalog: boolean;
  disabled?: boolean;
  className?: string;
};

const AddToCatalog = ({
  packageId,
  packageName,
  inCatalog,
  disabled = false,
  className,
}: AddToCatalogProps): React.JSX.Element => {
  const [updatePackage] = useUpdatePackageMutation();
  const unpublishDialog = useDialog();

  const toggleCatalog = () =>
    updatePackage({
      packageId,
      body: { in_catalog: !inCatalog },
    });

  return (
    <>
      <Button
        color="secondary"
        startIcon={inCatalog ? <RemoveCircleOutlineIcon /> : <AddIcon />}
        onClick={() => {
          if (inCatalog) {
            unpublishDialog.open();
          } else {
            toggleCatalog();
          }
        }}
        tooltipTitle={disabled ? CATALOG_PUBLISH_CONDITION : undefined}
        disabled={disabled}
        className={className}
      >
        {inCatalog ? "Unpublish from catalog" : "Publish to catalog"}
      </Button>
      {unpublishDialog.isOpen && (
        <Dialog
          title={
            <>
              Unpublish <em>{packageName}</em> from Catalog?
            </>
          }
          confirmText="Yes, unpublish"
          isOpen={unpublishDialog.isOpen}
          onCancel={unpublishDialog.close}
          onClose={unpublishDialog.close}
          onConfirm={() => {
            toggleCatalog();
            unpublishDialog.close();
          }}
        >
          Package <b>{packageName}</b> will no longer be available in the
          software catalog. You can publish it again at any time.
        </Dialog>
      )}
    </>
  );
};

export default AddToCatalog;
